import React from 'react';
import { Grid, Typography, Box, Table, TableBody, TableCell, TableHead, TableRow, FormControlLabel } from '@material-ui/core';
import PropTypes from 'prop-types';

import DetailsRowAmount from '../../../../shared/components/UI/DetailsRowAmount';
import StyledCheckbox from '../../../../shared/components/UI/StyledCheckbox';
import withUserContext from '../../../../shared/contexts/userContext/withUserContext';
import { getCurrencyCodeFromUserContext } from '../../../../shared/utils/helpers';
import { formatAmount } from '../../../../shared/utils/formatters';

const ReadonlyContractValueLimitSection = ({
  contractValueLimitEnabled,
  contractValueLimit,
  signerOverrides,
  userContext
}) => {

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h3" gutterBottom>
          Contract Value Limits
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          control={
            <StyledCheckbox
              checked={contractValueLimitEnabled}
              disabled
            />
          }
          label="Limit Contract Total Amount"
        />
      </Grid>

      {contractValueLimitEnabled && (
        <>
          <Grid item xs={12}>
            <DetailsRowAmount 
              title="Contract Value Limit" 
              amount={contractValueLimit}
              subscript="Base limit for all users"
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h3" gutterBottom>
              User Override Total Amount
            </Typography>
            <Typography variant="caption" color="textSecondary" gutterBottom>
              Set custom limits for specific users that override the base limit above.
            </Typography>
            {signerOverrides && signerOverrides.length > 0 ? (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>User Name</TableCell>
                    <TableCell align="right">Limit Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {signerOverrides.map(override => (
                    <TableRow key={override.id}>
                      <TableCell>{override.staff.user.fullName}</TableCell>
                      <TableCell align="right">
                        {formatAmount(parseFloat(override.contractValueLimit), getCurrencyCodeFromUserContext(userContext))}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <Typography variant="body2" color="textSecondary">
                No user overrides configured
              </Typography>
            )}
          </Grid>
        </>
      )}
    </Grid>
  );
};

ReadonlyContractValueLimitSection.propTypes = {
  contractValueLimitEnabled: PropTypes.bool.isRequired,
  contractValueLimit: PropTypes.number,
  signerOverrides: PropTypes.array,
  userContext: PropTypes.object
};

export default withUserContext(ReadonlyContractValueLimitSection);
